var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Draggable',{staticClass:"activity-image-buttons",attrs:{"animation":"150","group":"dragAndDropActivity","list":_vm.enhancedData}},_vm._l((_vm.enhancedData),function(image){return _c('div',{key:image.data.id,staticClass:"activity-image-buttons__wrap"},[_c('ActivityImageButton',{attrs:{"src":_vm.isOnline
          ? image.data.value
          : _vm.findPreloadedAsset('image', image.data.value)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }